import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-payment-confirmation',
  template: '',
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      html:has(iframe) {
        body.jakoo {
          display: none;
        }
      }
    `,
  ],
})
export class PaymentConfirmationComponent implements OnInit, OnDestroy {
  private onDestroy$: Subject<any> = new Subject();
  constructor(private router: Router) {}

  ngOnInit() {}
  ngOnDestroy(): void {
    this.onDestroy$.next(undefined);
    this.onDestroy$.complete();
  }

  private inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  private navigateToReviewOrder() {
    const navigationExtrasEmpty: NavigationExtras = {
      queryParams: {},
      replaceUrl: true,
    };
    this.router.navigate(['/checkout/review-order'], navigationExtrasEmpty);
  }
}
